import * as Types from '../constants/Types';

export const dataAllPropertyAction = () => ({type: Types.PROPERTY_LIST_ALL_ACTION});
export const dataAllPropertySuccess = (allProperties) => ({type: Types.PROPERTY_LIST_ALL_SUCCESS, allProperties});

export const getAllTourPropertyAction = () => ({type: Types.PROPERTY_TOUR_LIST_ALL_ACTION});
export const setAllTourPropertySuccess = (allProperties) => ({type: Types.PROPERTY_TOUR_LIST_ALL_SUCCESS, allProperties});

export const dataPropertyAction = (filters) => ({type: Types.PROPERTY_LIST_ACTION, filters});
export const dataPropertySuccess = (properties) => ({type: Types.PROPERTY_LIST_SUCCESS, properties});

export const createPropertyAction = (params) => ({type: Types.PROPERTY_CREATE_ACTION, params});
export const deletePropertyAction = (params) => ({type: Types.PROPERTY_DELETE_ACTION, params});

export const getUpdatePropertyAction = (params) => ({type: Types.PROPERTY_GET_UPDATE_ACTION, params});
export const getUpdatePropertySuccess = (dataUpdate) => ({type: Types.PROPERTY_GET_UPDATE_SUCCESS, dataUpdate});

export const updatePropertyAction = (params) => ({type: Types.PROPERTY_UPDATE_ACTION, params});

export const createPropertyTranslate = (property) => ({type: Types.PROPERTY_CREATE_TRANSLATE_ACTION, property});
export const updatePropertyTranslate = (property) => ({type: Types.PROPERTY_UPDATE_TRANSLATE_ACTION, property});
export const deletePropertyTranslate = (property, refreshParams) => ({type: Types.PROPERTY_DELETE_TRANSLATE_ACTION, property, refreshParams});
